const delay = (time) => new Promise(resolve => setTimeout(resolve, time))

export default delay